<template>
<svg viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ChuFangDianQi3`]" width="1em" height="1em" v-bind="$attrs"><path d="M16.7449 0.382812H9.28111C8.00655 0.382812 6.96973 1.41961 6.96973 2.69419V22.21C6.96973 23.4845 8.00652 24.5213 9.28111 24.5213H16.7449C18.0195 24.5213 19.0563 23.4845 19.0563 22.21V2.69419C19.0563 1.41963 18.0195 0.382812 16.7449 0.382812ZM9.28111 1.92374H16.7449C17.1697 1.92374 17.5154 2.26948 17.5154 2.69419V11.7768H8.51066V2.69419C8.51066 2.26946 8.85637 1.92374 9.28111 1.92374ZM16.7449 22.9804H9.28111C8.85637 22.9804 8.51066 22.6347 8.51066 22.21V13.3177H17.5154V22.21C17.5154 22.6347 17.1697 22.9804 16.7449 22.9804Z" :fill="useCurrentColor ? 'currentColor' : '#8C6FFF'"/><rect x="8.365" y="2.006" width="9.321" height="9.881" rx="1" :fill="useCurrentColor ? 'currentColor' : '#F0ECFF'"/><path d="M9.83173 11.0047C10.2572 11.0047 10.6022 10.6598 10.6022 10.2343V9.46381C10.6022 9.03833 10.2572 8.69336 9.83173 8.69336 9.40625 8.69336 9.06128 9.03833 9.06128 9.46381V10.2343C9.06125 10.6597 9.40625 11.0047 9.83173 11.0047zM9.83173 14.0879C9.40625 14.0879 9.06128 14.4329 9.06128 14.8583V15.6288C9.06128 16.0543 9.40625 16.3992 9.83173 16.3992 10.2572 16.3992 10.6022 16.0543 10.6022 15.6288V14.8583C10.6022 14.4329 10.2572 14.0879 9.83173 14.0879z" :fill="useCurrentColor ? 'currentColor' : '#8C6FFF'"/></svg>
</template>
<script>

export default {
  name: 'IconChuFangDianQi3',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
